export default "__VITE_ASSET__SnuWm$Lc__"